import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../../../../util/assets';
import Button from '../../../../../../../../../../../components/global/Button';
import Badge from '../../../../../../../../../../../components/global/Badge';
import PriceDisplay from '../../../../../../../../../../../components/global/PriceDisplay';
import AddedToCartLabel from '../../../../../PhotoPurchasingOptions/AddedToCartLabel';

const propTypes = {
  className: PropTypes.string,
  printProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
    preview_asset_image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
  printProductSize: PropTypes.shape({
    id: PropTypes.string.isRequired,
    print_size: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    mounts: PropTypes.shape({
      total: PropTypes.number.isRequired,
    }).isRequired,
    total_price: PropTypes.shape({
      value: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onPrintProductSizeSelect: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  getPrintProductSizePrice: PropTypes.func,
  isInCart: PropTypes.bool,
  prePaid: PropTypes.bool,
};

const PrintProductSize = ({
  className,
  printProduct,
  printProductSize,
  onPrintProductSizeSelect,
  readOnly,
  getPrintProductSizePrice,
  isInCart,
  prePaid,
}) => {
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-print-product-size': true,
  });
  const previewImage =
    printProductSize.preview_asset_image?.url ??
    printProduct.preview_asset_image?.url;
  const price = getPrintProductSizePrice
    ? getPrintProductSizePrice(printProduct, printProductSize)
    : printProductSize.total_price;

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img
          width={previewImage ? 80 : 60}
          src={previewImage || getAsset('/simple-prints-illustration.svg')}
          alt=""
        />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <span className="purchasing-option-item-title">
          <div className="text-truncate">
            {printProductSize.print_size.name}
          </div>
          <div className="purchasing-option-item-info-extra">
            <Badge badgeStyle="yellow" className="text-extra-bold">
              <PriceDisplay price={price.value} currency={price.currency} />
            </Badge>
          </div>
        </span>

        <div className="purchasing-option-item-content mb-2">
          <p className="text-sm lh-normal text-dark text-bold">
            {printProduct.name}
            {printProductSize?.mounts?.total > 0 &&
              ' (mounting options available)'}
          </p>
        </div>

        {!readOnly && (
          <Button
            className={classNames({
              'purchasing-options-item-btn': true,
              'btn-purchase-options-in-cart': isInCart,
            })}
            btnStyle={classNames({
              primary: !isInCart,
              info: isInCart,
            })}
            data-testid="btn-print-product-shop"
            onClick={() => {
              onPrintProductSizeSelect(printProductSize);
            }}
          >
            {prePaid && (
              <Fragment>{isInCart ? 'In cart' : 'Add to cart'}</Fragment>
            )}
            {!prePaid && (
              <Fragment>
                {isInCart ? <AddedToCartLabel /> : 'Configure and buy'}
              </Fragment>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

PrintProductSize.propTypes = propTypes;

export default PrintProductSize;
